<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>昨日报告</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <el-date-picker v-model="dateValue" type="date" placeholder="选择日期" clearable :picker-options="pickerOptions"
                @change="handleDateChange">
            </el-date-picker>
            <div style="margin-left: 30px;">新注册人数：{{ yesterdayReportInfo.registration_count }}</div>
            <div style="margin-left: 30px;">总计支付金额：{{ yesterdayReportInfo.total_payment / 100 }}元</div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="yesterdayReportList" ref="yesterdayReportList" style="width: 100%" size="mini" stripe>
                <el-table-column prop="invited_by_name" label="邀请人" fixed="left"></el-table-column>
                <el-table-column prop="invited_by" label="邀请人id">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" @click="getOrderDetails(scope.row.invited_by)">{{
                            scope.row.invited_by }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="user_id" label="被邀请人id">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="getOrderDetails(scope.row.user_id)">{{
                            scope.row.user_id }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="community" label="社区"></el-table-column>
            </el-table>
        </div>
        <div class="block" v-if="false">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="个人信息" :visible.sync="dialogAddData" center @close="closeDialogAdd" width="30%">
            <el-form :model="userInfo" ref="userInfo">
                <div class="dialog_style">
                    <div class="flex_box">
                        <div>姓名:</div>
                        <div>性别:</div>
                        <div>年龄:</div>
                        <div>出生日期:</div>
                        <div>身高:</div>
                        <div>体重:</div>
                        <div>基础病:</div>
                        <div>大病史:</div>
                        <div>身份:</div>
                    </div>
                    <div class="right_box">
                        <div class="el_from_span">{{ userInfo.name || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.gender || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.age || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.birthday || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.height || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.weight || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.basic_diseases || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.serious_illness || '无' }}</div>
                        <div class="el_from_span">{{ userInfo.role }}</div>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            pages: 1,
            limit: 10,
            yesterdayReportList: [],
            total: 0,
            dialogDelete: false,
            clickObject: {},
            dialogModifyData: false,
            modifyData: {
                category: {
                    id: ''
                },
                task_name: '',
                day: '',
                description: '',
                task_id: '',
            },
            formLabelWidth: '150px',
            userInfo: {},
            dialogAddData: false,
            dateValue: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            yesterdayReportInfo: {}
        }
    },
    created() {
        this.getYesterdayReportList()
    },
    methods: {
        getYesterdayReportList() {
            this.$get(`/v1/admin/yesterday-report?&date=${this.dateValue}`, {}).then((res) => {
                this.yesterdayReportList = res.data.new_users_info
                this.yesterdayReportInfo = res.data
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getTaskList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getTaskList()
        },
        clickEdit(index, row) {
            console.log(index, row);
            this.modifyData = row
            this.dialogModifyData = true
        },
        clickDelete(index, row) {
            console.log(index, row);
            this.dialogDelete = true
            this.delData = row
            console.log(this.delData, '00000000000000')
        },
        closeDialogAdd() {
            this.dialogAddData = false;
        },
        getOrderDetails(id) {
            this.getUserList(id)
        },
        getUserList(id) {
            this.$get(`/v1/user-basic-info?id=${id}`, {}).then((res) => {
                console.log(res.data.data)
                if (res.data.data.length === 0 || Object.keys(res.data.data).length === 0) {
                    this.$msg('数据为空')
                    return
                }
                let userInfo = res.data.data.data
                if (userInfo.basic_diseases == '。') {
                    userInfo.basic_diseases = ''
                }
                if (userInfo.birthday != '') {
                    userInfo.birthday = userInfo.birthday.split(' ')[0]
                }
                this.userInfo = userInfo
                this.dialogAddData = true
            });
        },
        handleDateChange(value) {
            // 用户选择日期后触发的方法
            const year = value.getFullYear();
            const month = value.getMonth() + 1; // 月份是从0开始的，所以需要加1
            const day = value.getDate();
            const selectedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

            this.dateValue = selectedDate
            this.getYesterdayReportList(); // 使用选择的日期发起请求
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 220px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>


// WEBPACK FOOTER //
// src/pages/yesterdayReport/yesterdayReport.vue